import { render, staticRenderFns } from "./ModalTransportInfo.vue?vue&type=template&id=208a2886&scoped=true"
import script from "./ModalTransportInfo.vue?vue&type=script&lang=js"
export * from "./ModalTransportInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalTransportInfo.vue?vue&type=style&index=0&id=208a2886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a2886",
  null
  
)

export default component.exports